import React from "react";
import { Trash } from "phosphor-react";
import styles from "./TrashcanButton.module.css";

const TrashcanButton = (props) => (
  <button
    type="button"
    id={props.id}
    name={props.name}
    className={styles.TrashcanButton}
    onClick={props.onClick}
    onKeyDown={(e) => (e.key === "Enter" ? props.onClick() : null)}
    {...props}
  >
    <Trash color="#FB3049" size={24} />
  </button>
);

export default TrashcanButton;
